/*! logger.js */

const LOG_LEVEL_METHODS = { 1: "error", 2: "warn", 3: "info", 4: "debug", 5: "trace" };

const DISABLED = 0;
const LOG = Symbol("log");
const LAST_LOG_LEVEL = Symbol("lastLogLevel");

const DEFAULT_REPORTER = {
    getConsole() {
        return console;
    }
};

const LOG_LEVELS = {
    "TRACE": 5,
    "DEBUG": 4,
    "INFO": 3,
    "WARN": 2,
    "ERROR": 1
};

const LogConfig = {
    LOG_LEVELS,
    minLogLevel: 0,
    useTimestamp: false,
    reporter: DEFAULT_REPORTER
};

/**
 * @class Log
 */
class Log {

    /**
     * @constructs Log
     * @param {string} label
     * @param {LogConfig} [config]
     */
    constructor(label, config = {}) {
        if (!label) {
            throw new Error("Logger label must be set");
        }

        this.label = label;
        this.logConfig = Object.assign(LogConfig, config);
        this[LAST_LOG_LEVEL] = this.logConfig.minLogLevel;
    }

    /**
     * @private
     * @param {LOG_LEVELS} level
     * @param {Array|Arguments} args
     */
    [LOG](level, args) {
        if (level <= this.logConfig.minLogLevel) {
            const _console = this.logConfig.reporter.getConsole();
            const logger = _console[LOG_LEVEL_METHODS[level]] || _console["log"];
            const loggerArguments = [`[BVP] ${ this.label }:`];
            if (this.logConfig.useTimestamp) {
                loggerArguments.push(Date.now());
            }
            logger.apply(_console, loggerArguments.concat(Array.prototype.slice.call(args)));
        }
    }

    /**
     * @static
     * @method
     * @returns {LOG_LEVELS}
     */
    static getLogLevels() {
        return LOG_LEVELS;
    }

    /**
     * @method
     * @param {LOG_LEVELS} [level]
     */
    setMinLogLevel(level = 1) {
        this.logConfig.minLogLevel = level;
    }

    /**
     * @method
     */
    enable() {
        this.setMinLogLevel(this[LAST_LOG_LEVEL]);
    }

    /**
     * @method
     */
    disable() {
        this[LAST_LOG_LEVEL] = this.logConfig.minLogLevel;
        this.setMinLogLevel(DISABLED);
    }

    /**
     * @method
     */
    trace() {
        this[LOG](LOG_LEVELS.TRACE, arguments);
    }

    /**
     * @method
     */
    debug() {
        this[LOG](LOG_LEVELS.DEBUG, arguments);
    }

    /**
     * @method
     */
    info() {
        this[LOG](LOG_LEVELS.INFO, arguments);
    }

    /**
     * @method
     */
    warn() {
        this[LOG](LOG_LEVELS.WARN, arguments);
    }

    /**
     * @method
     */
    error() {
        this[LOG](LOG_LEVELS.ERROR, arguments);
    }
}

export default Log;
